import { useUnit } from "effector-react"
import { useEffect, useMemo } from "react"

import { $isFetchWorkingDaysCalendars, $workingDaysCalendars, $workingDaysCalendarsMap, fetchWorkingDaysCalendars, } from "stores/workingDaysCalendars"
interface IUseWorkingDaysCalendarsProps {
    autoload?: boolean
}
export default function useWorkingDaysCalendars({ autoload }: IUseWorkingDaysCalendarsProps = { autoload: false }) {
    const workingDaysCalendars = useUnit($workingDaysCalendars)
    const workingDaysCalendarsMap = useUnit($workingDaysCalendarsMap)
    const isLoading = useUnit($isFetchWorkingDaysCalendars)

    const workingDaysCalendarsOptions = useMemo(() => {
        return workingDaysCalendars?.items?.map(wDC => ({
            label: wDC.description,
            value: wDC.id,
        })) ?? []
    }, [workingDaysCalendars?.items])

    useEffect(() => {
        if (autoload && !workingDaysCalendars) {
            fetchWorkingDaysCalendars()
        }
    }, [fetchWorkingDaysCalendars, workingDaysCalendars])

    return {
        workingDaysCalendars,
        workingDaysCalendarsMap,
        isLoading,
        fetchWorkingDaysCalendars,
        workingDaysCalendarsOptions
    }
}

